import { Box } from "@mui/material";
import ProcessBlock from "./ProcessBlock";
import { useHistory, useRouteMatch } from "react-router-dom";
import { useCallback } from "react";
import { useSelector } from "react-redux";
import { refereeStatusSelector } from "../../../store/refereeSlice";

export default function ProcessBar({ procceses, baseurl }) {
  const history = useHistory();
  const refereeStatus = useSelector(refereeStatusSelector);
  const IsActive = (route) => {
    const match = useRouteMatch({
      path: `${baseurl}${route}`,
      strict: false,
    });
    if (!match) return false;
    return true;
  };

  const findStatus = useCallback(
    (label) => {
      if(!refereeStatus) return;
      if (label === "Detailed evaluation") {
        return refereeStatus.detaliedEvaluation ? 2 : 1;
      }
      if (label === "Grading (%)") {
        return refereeStatus.grading ? 2 : 1;
      }
      if (label === "Final Recommendation") {
        return refereeStatus.finalRecommendation ? 2 : 1;
      }
      return 0;
    },
    [refereeStatus]
  );

  const handleOnClick = (module) => {
    history.push(`${baseurl}${module.route}`);
  };

  return (
    <Box className="stepper" maxWidth="lg">
      {procceses.map((m) => (
        <ProcessBlock
          onClick={() => handleOnClick(m)}
          key={m.route}
          text={m.text}
          active={IsActive(m.route)}
          // status={0}
          status={findStatus(m.text)}
        />
      ))}
    </Box>
  );
}
